module.exports = __webpack_public_path__ + "files/36ae6c4e95e44a959faca91fc612c70d.png";